import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartOfAccounts = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 1.5,
			width: 13,
			height: 13,
			rx: 2,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 4.25,
			width: 12,
			height: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 7.5,
			width: 12,
			height: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 10.75,
			width: 12,
			height: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.52039 5H5.52039V14H4.52039V5Z",
			fill: "currentColor"
		})
	]
});
export default SvgChartOfAccounts;
